<template>
  <div class="bg-lightblue policy-page">
    <header>
      <div class="container flex">
        <div class="policy-page__logo">
          <img
            alt="Логотип"
            class="head-panel__logo"
            src="@/assets/img/logo/logo.png"
          />
          <div>Программа для стоматологических<br />клиник</div>
        </div>
        <removable-feature feature="registration">
          <router-link
            class="policy-page__button"
            v-bind:to="{ name: 'Registration' }"
          >
            Регистрация
          </router-link>
        </removable-feature>
      </div>
    </header>
    <main>
      <div class="container">
        <h1>Политика конфиденциальности</h1>
        <div class="policy-page__text">
          Настоящая Политика конфиденциальности персональной информации
          (далее — Политика) действует в отношении всей информации, которую ТОО «32топ»
          (далее — Администрация Сайта) может получить о пользователе во время
          использования им сайта mis.32top.kz. (далее — Сайт). Использование сайта
          означает безоговорочное согласие пользователя с настоящей Политикой
          и указанными в ней условиями обработки его персональной информации;
          в случае несогласия с этими условиями пользователь должен воздержаться
          от использования данного ресурса.
        </div>
        <div class="policy-page__text">
          <ol class="policy-page__main-list">
            <li>
              <h2>
                Персональная информация пользователей, которую получает
                и обрабатывает Администрация Сайта.
              </h2>
              <ol>
                <li>
                  В рамках настоящей Политики под «персональной информацией пользователя»
                  понимаются:
                  <ol>
                    <li>
                      Персональная информация, которую пользователь предоставляет
                      о себе самостоятельно при регистрации
                      (создании учётной записи) или в ином процессе использования Сайта.
                    </li>
                    <li>
                      Данные, которые автоматически передаются Сайтом в процессе
                      его использования с помощью установленного на устройстве
                      пользователя программного обеспечения, в том числе
                      IP-адрес, информация из cookie, информация о браузере
                      пользователя (или иной программе, с помощью которой
                      осуществляется доступ к Сайту), время доступа, адрес
                      запрашиваемой страницы.
                    </li>
                    <li>
                      Данные, которые предоставляются Администрации Сайта, в целях
                      осуществления оказания услуг и/или предоставления иных
                      ценностей для пользователей Сайта, в соответствии с
                      деятельностью настоящего ресурса: имя, фамилия,
                      электронная почта, номер телефона.
                    </li>
                  </ol>
                </li>
                <li>
                  Предоставляя свои персональные данные при регистрации на Сайте,
                  пользователь даёт Администрации Сайта своё согласие на обработку
                  и использование своих персональных данных согласно Закона Республики
                  Казахстан от 21 мая 2013 года №94-V «О персональных данных
                  и их защите» различными способами в целях, указанных в п. 2 данной
                  Политики.
                </li>
              </ol>
            </li>
            <li>
              <h2>
                Цели сбора и обработки персональной информации.
              </h2>
              <ol>
                <li>
                  Сайт собирает и хранит только ту персональную информацию, которая
                  необходима для предоставления сервисов, за исключением случаев,
                  когда законодательством предусмотрено обязательное хранение
                  персональной информации в течение определенного законом срока.
                </li>
                <li>
                  Персональную информацию Пользователя Сайт обрабатывает
                  в следующих целях:
                  <ol>
                    <li>
                      Предоставление пользователю персонализированных услуг
                      и сервисов и иных ценностей.
                    </li>
                    <li>
                      Связь с пользователем, в том числе направление уведомлений,
                      запросов и информации, касающихся использования Сайта,
                      оказания услуг.
                    </li>
                    <li>
                      Подтверждения достоверности и полноты персональных данных,
                      предоставленных Пользователем.
                    </li>
                    <li>
                      Предоставления Пользователю эффективной клиентской
                      и технической поддержки при возникновении проблем, связанных
                      с использованием Сайта.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <h2>
                Условия обработки персональной информации пользователя и её
                передачи третьим лицам.
              </h2>
              <ol>
                <li>
                  Администрация Сайта хранит персональную информацию
                  пользователей в соответствии с внутренними регламентами
                  конкретных сервисов.
                </li>
                <li>
                  В отношении персональной информации пользователя
                  сохраняется ее конфиденциальность, кроме случаев
                  добровольного предоставления пользователем информации о себе
                  для общего доступа неограниченному кругу лиц.
                </li>
                <li>
                  Администрация Сайта вправе передать персональную информацию
                  пользователя третьим лицам в следующих случаях:
                  <ol>
                    <li>
                      Пользователь выразил свое согласие на такие действия,
                      путем согласия выразившегося в предоставлении таких данных;
                    </li>
                    <li>
                      Передача необходима в рамках использования пользователем
                      данного Сайта, либо для оказания услуги пользователю;
                    </li>
                    <li>
                      Передача предусмотрена российским, казахстанским
                      или иным применимым законодательством в рамках
                      установленной законодательством процедуры;
                    </li>
                    <li>
                      В целях обеспечения возможности защиты прав
                      и законных интересов Администрация Сайта или
                      третьих лиц в случаях, когда пользователь нарушает
                      Пользовательское соглашение Сайта.
                    </li>
                  </ol>
                </li>
                <li>
                  При обработке персональных данных пользователей Администрация Сайта
                  применяет правовые, организационные и технические меры
                  по обеспечению безопасности персональных данных в соответствии
                  с Законом Республики Казахстан от 21 мая 2013 года №94-V
                  «О персональных данных и их защите». Администрация Сайта
                  принимает необходимые и достаточные организационные и технические меры
                  для защиты персональной информации пользователя от неправомерного или
                  случайного доступа, уничтожения, изменения, блокирования,
                  копирования, распространения, а также от иных неправомерных
                  действий с ней третьих лиц.
                </li>
              </ol>
            </li>
            <li>
              <h2>Обязательства сторон.</h2>
              <ol>
                <li>
                  Пользователь обязан предоставить информацию о персональных данных,
                  необходимую для пользования Сайтом.
                </li>
                <li>
                  Администрация Сайта обязана:
                  <ol>
                    <li>
                      Использовать полученную информацию исключительно для
                      целей, указанных в настоящей Политике конфиденциальности.
                    </li>
                    <li>
                      Обеспечить хранение конфиденциальной информации в тайне, не разглашать без
                      предварительного письменного разрешения Пользователя,
                      а также не осуществлять продажу, обмен, опубликование
                      либо разглашение иными возможными способами переданных персональных данных
                      Пользователя, за исключением предусмотренных настоящей Политикой
                      конфиденциальности и Законодательством Казахстана.
                    </li>
                    <li>
                      Принимать меры предосторожности для защиты конфиденциальности персональных
                      данных Пользователя согласно порядку, обычно используемому
                      для защиты такого рода информации в существующем деловом обороте.
                    </li>
                    <li>
                      Осуществить блокирование персональных данных, относящихся к соответствующему
                      Пользователю, с момента обращения или запроса Пользователя или его законного
                      представителя либо уполномоченного органа по защите прав субъектов
                      персональных данных на период проверки в случае выявления недостоверных
                      персональных данных или неправомерных действий.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <h2>
                Изменение пользователем персональной информации:
              </h2>
              <ol>
                <li>
                  Пользователь может в любой момент отозвать свое согласие на обработку
                  персональных данных, оставив заявление в адрес Администрации
                  Сайта: Email: zakaz@32top.kz, 010000, Казахстан, Есиль р-он,
                  г. Астана, ул. Достык, д. 5.
                </li>
              </ol>
            </li>
            <li>
              <h2>
                Изменение Политики конфиденциальности. Применимое законодательство.
              </h2>
              <ol>
                <li>
                  Администрация Сайта имеет право вносить изменения в настоящую
                  Политику конфиденциальности. При внесении изменений в актуальной
                  редакции указывается дата последнего обновления. Новая редакция Политики
                  вступает в силу с момента ее размещения, если иное не
                  предусмотрено новой редакцией Политики.
                </li>
                <li>
                  К настоящей Политике и отношениям между пользователем
                  и Администрацией Сайта, возникающим в связи с применением Политики
                  конфиденциальности, подлежит применению право Республики Казахстан.
                </li>
              </ol>
            </li>
          </ol>
        </div>
      </div>
      <footer>
        <div class="container flex">
          <div>
            2008-{{ currentYear }}© mis.32top.kz
          </div>
          <router-link
            class="policy-page__link"
            v-bind:to="{ name: 'PrivacyPolicy' }"
          >
            Политика конфиденциальности
          </router-link>
        </div>
      </footer>
    </main>
  </div>
</template>
<script>
import RemovableFeature from '@/components/RemovableFeature.vue';
import aboutMixin from '@/mixins/aboutMixin';

/**
 * @description Компонент политики конфиденциальности.
 */
export default {
  components: {
    RemovableFeature,
  },
  data() {
    return {
      currentYear: (new Date()).getFullYear(),
    };
  },
  mixins: [
    aboutMixin,
  ],
  name: 'PrivacyPolicy',
};
</script>
<style scoped lang="scss">
@use "@/scss/buttons";

main {
  flex: 1;
  overflow-y: auto;
}

.bg-lightblue {
  background: linear-gradient(
    180deg,
    #e2f8ff 53.71%,
    rgba(213, 237, 255, 0) 100%
  );
}

.policy-page {
  height: 100vh;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  header {
    padding: 8px 0;
    border-bottom: 1px solid rgba(0, 163, 255, 0.2);
  }

  &__link,
  footer > div {
    color: #000 !important;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }

  &__link:hover {
    text-decoration: none;
  }

  &__logo {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 16px;
    color: rgba(40, 49, 67, 0.7);
    gap: 25px;
  }

  &__main-list {
    display: grid;
    row-gap: 10px;
  }

  &__list-title {
    font-weight: 600;
  }

  &__text {
    margin: 10px;
  }

  &__button {
    @include buttons.btn-blue(160px, 40px, 16px);
    color: white !important;
    text-decoration: none;
  }

  h1 {
    font-weight: 700;
    font-size: 45px;
    line-height: 59px;
    margin-bottom: 50px;
  }

  h2 {
    font-weight: 500;
  }

  p {
    display: block;
    margin-block: 15px !important;
  }

  ul {
    margin: 20px 0;
    padding-left: 0;
    overflow-wrap: anywhere;
    > li {
      position: relative;
      margin-block: 10px;
      padding-left: 30px;
      list-style-type: none;
      &::before {
        content: "";
        position: absolute;
        top: .6em;
        left: 0;
        width: 16px;
        height: 4px;
        background: #00a3ff;
        border-radius: 10px;
        transform: translateY(-50%);
      }
    }
  }

  ol {
    margin: 20px 0;
    padding-left: 30px;
    counter-reset: li;
    overflow-wrap: anywhere;
    > li {
      padding-left: 10px;
      counter-increment: li;
      &::marker {
        content: counters(li, ".") ". ";
        font-size: 1.5em;
        font-weight: 600;
        color: #00a3ff;
      }
    }
  }

  footer {
    border-top: 1px solid #bfdaec;
    padding: 16px 0;
  }

  footer > .flex {
    max-width: 600px;
  }
}

.flex {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}

@media screen and (max-width: 986px) {
  .policy-page {
    h1 {
      font-size: 38px;
      line-height: 48px;
    }
  }
}

@media screen and (max-width: 768px) {
  .policy-page {
    h1 {
      font-size: 26px !important;
      line-height: 30px !important;
      margin-bottom: 25px;
    }
  }
}

@media screen and (max-width: 600px) {
  .policy-page {
    &__logo > div {
      display: none;
    }
  }
  footer > .flex {
    flex-direction: column;
    align-items: start;
    gap: 5px;
  }
}

@media screen and (max-width: 400px) {
  .policy-page {
    h2 {
      font-size: 22px;
      line-height: normal;
    }
    ol {
      font-size: 14px;
      > li::marker {
        font-size: 22px;
      }
    }
  }
}
</style>
